import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AddedEntity } from '../../../shared/models/api-results/base.api-result';
import { prepareQueryParams, convertToFormData } from '../../../shared/utils/api-transformations';
import {
  AddPodcastPayload,
  PodcastQueryData,
  UpdatePodcastPayload,
  UpdatePodcastPicturePayload,
} from '../../../shared/models/payloads/podcast.payload';
import {
  ListPodcastsResult,
  PodcastResult,
  UpdatePodcastPictureResult,
} from '../../../shared/models/api-results/podcast.api-result';

@Injectable({
  providedIn: 'root',
})
export class HttpPodcastService {
  constructor(private http: HttpClient) {}

  get(id: string) {
    return this.http
      .get(`${environment.api_base_url}/podcasts/get_details_of_a_podcast/${id}`)
      .pipe(map((res) => res as PodcastResult));
  }

  // nnkitodo [v2later] supprimer
  getIos(id: number, accessToken: string) {
    return this.http
      .get(`${environment.api_base_url}/podcasts/get_details_of_a_podcast/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .pipe(map((res) => res as PodcastResult));
  }

  list(params: PodcastQueryData) {
    return this.http
      .get(`${environment.api_base_url}/podcasts/list_podcasts`, {
        params: prepareQueryParams(params),
      })
      .pipe(map((res) => res as ListPodcastsResult));
  }

  incrementViews(id: string) {
    return this.http.post(`${environment.api_base_url}/podcasts/consult_podcast/${id}`, {});
  }

  // nnkitodo [v2later] supprimer
  incrementViewsIos(id: string, accessToken: string) {
    return this.http.post(`${environment.api_base_url}/podcasts/consult_podcast/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  wGet(id: string) {
    return this.http
      .get(`${environment.api_base_url}/podcasts/admin/get_details_of_a_podcast/${id}`)
      .pipe(map((res) => res as PodcastResult));
  }

  wList(params: PodcastQueryData) {
    return this.http
      .get(`${environment.api_base_url}/podcasts/admin/list_podcasts`, {
        params: prepareQueryParams(params),
      })
      .pipe(map((res) => res as ListPodcastsResult));
  }

  wAdd(payload: AddPodcastPayload) {
    return this.http
      .post(`${environment.api_base_url}/podcasts/add_podcast`, convertToFormData(payload))
      .pipe(map((res) => res as AddedEntity));
  }

  wDelete(id: string) {
    return this.http.post(`${environment.api_base_url}/podcasts/delete_podcast/${id}`, {});
  }

  wUpdate(id: string, payload: UpdatePodcastPayload) {
    return this.http.post(`${environment.api_base_url}/podcasts/update_podcast/${id}`, payload);
  }

  wUpdatePicture(id: string, payload: UpdatePodcastPicturePayload) {
    return this.http
      .post(
        `${environment.api_base_url}/podcasts/update_podcast_picture/${id}`,
        convertToFormData(payload)
      )
      .pipe(map((res) => res as UpdatePodcastPictureResult));
  }
}
